module.exports = __webpack_public_path__ + "static/ramentruffe-fb7ed26ef245fa46d3e384e8e5a239b8.jpg";